import * as React from 'react';
import { useSelector } from 'react-redux';
import ErrorAlert from '../../../components/ErrorAlert';
import { RootState } from '../../../store/rootStore';

const LibrariesError = () => {
  const { libraries } = useSelector((state: RootState) => state.libraries);

  return <ErrorAlert error={libraries.request.get.error} />;
};

export default LibrariesError;
